import { CircularProgress } from '@mui/material';
import { DateTime } from 'luxon';

import { EstimationVariancePoint } from '@/features/TimeStatsModel';

import { EstimationVarianceAxisChart } from './EstimationVarianceAxisChart';
import { EstimationVarianceCategoryChart } from './EstimationVarianceCategoryChart';

import s from './TimeEstimationScatterChart.module.scss';

type TimeEstimationScatterChartProps = {
  points: EstimationVariancePoint[];
  periodStart: DateTime | null;
  periodEnd: DateTime | null;
  isLoading: boolean;
  isError: boolean;
  failedCount: number;
  skippedCount: number;
};

export const TimeEstimationScatterChart: React.FC<TimeEstimationScatterChartProps> = ({
  points,
  periodStart,
  periodEnd,
  isLoading,
  isError,
  failedCount,
  skippedCount,
}) => {
  if (isLoading) {
    return (
      <div className={s.chart__status} data-testid="estimation-chart-loading">
        <CircularProgress size={24} />
        <p>Загрузка данных по задачам…</p>
      </div>
    );
  }

  if (isError && points.length === 0) {
    return (
      <div className={s.chart__status} data-testid="estimation-chart-error">
        Не удалось загрузить данные по задачам
      </div>
    );
  }

  if (points.length === 0) {
    return (
      <div className={s.chart__status} data-testid="estimation-chart-empty">
        Нет задач с оценкой за выбранный период
      </div>
    );
  }

  return (
    <div>
      <div className={s.chart}>
        <EstimationVarianceAxisChart
          points={points}
          periodStart={periodStart}
          periodEnd={periodEnd}
        />
        <EstimationVarianceCategoryChart points={points} />
      </div>
      {(failedCount > 0 || skippedCount > 0) && (
        <p className={s.chart__meta}>
          Пропущено без оценки или логов: {skippedCount}. Ошибок загрузки: {failedCount}.
        </p>
      )}
    </div>
  );
};
